// *********************************
// CoolGames Builder JavaScript file
// *********************************
import { LeaderboardType } from "@cg-be-package/nakama-gamesparks-shim";
import { leaderboardService } from "../../game_theme/flow_fb/flowController";
import { ExpSettings } from "../settings/Settings";
import { AngryAnalytics } from "./Analytics/Analytics";
import { FriendManager } from "./FriendManager";
import { tgfHooks } from "../framework/hooks/hooks";
import { YoutubeStorageManager } from "./storage/YoutubeStorageManager";
export var ExpManager = {
    EXPERIENCE_TAG: "experience",
    RANK_TAG: "rank",
    _isInitialized: false,
    _currentExp: null,
    _currentRank: null,
    friendRanks: {},
    initialize: function () {
        var self = this;
        return new Promise(function (resolve, reject) {
            YoutubeStorageManager.getPlayerData([self.EXPERIENCE_TAG, self.RANK_TAG], function (data) {
                self._currentExp = data[self.EXPERIENCE_TAG] || 0;
                self._currentRank = data[self.RANK_TAG] || 1;
                AngryAnalytics.reportExpRankStatus(self._currentRank);
                if (!data[self.EXPERIENCE_TAG] || !data[self.RANK_TAG]) {
                    YoutubeStorageManager.savePlayerData([self.EXPERIENCE_TAG, self.RANK_TAG], [self._currentExp, self._currentRank]);
                }
                self._isInitialized = true;
                self.loadAllFriendRanks().then(function () {
                    resolve();
                }).catch(function (err) {
                    console.error(err);
                    reject();
                });
            }, function (err) {
                console.error(err);
                reject();
            });
        });
    },
    getExp: function () {
        if (!this._isInitialized)
            throw new Error("ExpManager is not initialized");
        return this._currentExp;
    },
    getRank: function () {
        if (!this._isInitialized)
            throw new Error("ExpManager is not initialized");
        return this._currentRank;
    },
    getRankAssets: function (rank) {
        if (!this._isInitialized)
            throw new Error("ExpManager is not initialized");
        if (rank === undefined) {
            rank = this._currentRank;
        }
        return ExpSettings.rankAssets[Math.min(rank - 1, ExpSettings.rankAssets.length - 1)];
    },
    getProgressPercentage: function (exp, rank) {
        if (!this._isInitialized)
            throw new Error("ExpManager is not initialized");
        if (exp === undefined) {
            exp = this._currentExp;
        }
        return Math.min(1, exp / this.getNeededExp(rank));
    },
    getNeededExp: function (rank) {
        if (!this._isInitialized)
            throw new Error("ExpManager is not initialized");
        rank = rank || this._currentRank;
        return ExpSettings.rankExpRequirements[Math.min(rank, ExpSettings.rankExpRequirements.length - 1)];
    },
    gainExp: function (amount) {
        if (!this._isInitialized)
            throw new Error("ExpManager is not initialized");
        this._currentExp += amount;
        while (this._currentExp >= this.getNeededExp()) {
            this._currentExp -= this.getNeededExp();
            this._currentRank++;
            AngryAnalytics.reportExpRankUpdate(this._currentRank);
        }
        YoutubeStorageManager.savePlayerData([this.EXPERIENCE_TAG, this.RANK_TAG], [this._currentExp, this._currentRank]);
    },
    loadFriendRanks: function (ids) {
        if (!this._isInitialized)
            throw new Error("ExpManager is not initialized");
        var self = this;
        return Promise.resolve([]);
        return leaderboardService.getLeaderboardData(new LeaderboardType(), ids.length, 0, [this.RANK_TAG], ids).then(function (data) {
            if (data && data.leaderboardData) {
                for (var i = 0; i < data.leaderboardData.length; i++) {
                    self.friendRanks[data.leaderboardData[i].userName] = data.leaderboardData[i].playerData[self.RANK_TAG] || 1;
                }
                return self.friendRanks;
            }
        });
    },
    loadAllFriendRanks: function () {
        if (!this._isInitialized)
            throw new Error("ExpManager is not initialized");
        var ids = FriendManager.getFriendIds();
        ids.push(tgfHooks.getPlayerID());
        return this.loadFriendRanks(ids);
    },
    getFriendRank: function (id) {
        return this.friendRanks[id] || 1;
    },
};
